import React from "react";
import { Routes, Route } from "react-router-dom";
import ListChats from "../Components/Chat Support Executive/listChats";
import ListChatsAdmin from "../Components/Chat Support Admin/listChatsAdmin";

const ChatRoutes = () => {
  return (
    <Routes>
      <Route
        path="/chat_and_support/pay_exec/:id"
        element={<ListChats></ListChats>}
      ></Route>
      <Route
        path="/chat_and_support"
        element={<ListChatsAdmin></ListChatsAdmin>}
      ></Route>
    </Routes>
  );
};

export default ChatRoutes;
